import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { countries, Country } from "../payment/payment.component";
import { AudioService } from "../../../../services/audio/audio.service";
import { PartSubscriberService } from "./part-subscriber.service";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: 'app-subs-modal',
  templateUrl: './subs-modal.component.html',
  styleUrl: './subs-modal.component.scss'
})
export class SubsModalComponent {
  @Input() part = 2;
  @Output()
  closed: EventEmitter<void> = new EventEmitter();

  readonly consentText =
  'Я принимаю Пользовательское соглашение и Политику обработки персональных данных. Если мне не исполнилось 18 лет, я использую Платформу с согласия родителя (законного представителя).';
  isEmailAuth = true;

  email = new FormControl("", [Validators.email, Validators.required]);
  phone = new FormControl('');

  
  hasError = false;
  errorText = '';

  acceptTerms = false;
  acceptSubs = false;

  isWaiting = false;

  showResult = false;
  constructor(
    private cdr: ChangeDetectorRef,
    private audio: AudioService,
    private partSubscriberService: PartSubscriberService,
  ) {}
  playBtnClick() {
    this.audio.playClickSmallBtn();
  }
  switchAuthType(isEmailAuth: boolean) {
    this.isEmailAuth = isEmailAuth;
  }

 subs() {
  this.hasError = false;
  this.errorText = '';

  if (this.isWaiting) {
    return;
  }

  if (!this.acceptTerms) {
    return;
  }

  if (this.isEmailAuth) {
    const emailRegex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const email = this.email.value?.trim();

    if (!email) {
      this.hasError = true;
      this.errorText = 'Поле обязательно для заполнения';
      return;
    }
    if (email.length > 100) {
      this.hasError = true;
      this.errorText = 'E-mail не должен быть длиннее 100 символов';
      return;
    }

    if (!emailRegex.test(email)) {
      this.hasError = true;
      this.errorText = 'Проверьте правильность написания E-mail';
      return;
    }
  } else {
    const phoneDigits =
      this.phone.value?.replace(/\D/g, '') || '';

    if (!phoneDigits) {
      this.hasError = true;
      this.errorText = 'Поле обязательно для заполнения';
      return;
    }

    if (phoneDigits.length < 11) {
      this.hasError = true;
      this.errorText =
        'Проверьте правильность написания номера телефона';
      return;
    }
  }

  this.isWaiting = true;

  if (this.isEmailAuth) {
    this.email.disable();
  } else {
    this.phone.disable();
  }

  const request = {
    part: this.part,
    consent: true,
    consent_text: this.consentText,

    ...(this.isEmailAuth
      ? {
          email: this.email.value!.trim()
        }
      : {
          phone: this.phone.value!
        })
  };

  this.partSubscriberService.subscribe(request).subscribe({
    next: response => {
      this.isWaiting = false;
      this.showResult = true;

      this.cdr.detectChanges();
    },

    error: error => {
      this.isWaiting = false;

      if (this.isEmailAuth) {
        this.email.enable();
      } else {
        this.phone.enable();
      }

      this.handleSubscriptionError(error);

      this.cdr.detectChanges();
    }
  });
  }

  private handleSubscriptionError(error: HttpErrorResponse): void {
    this.hasError = true;

    if (error.status === 422) {
      const field = this.isEmailAuth ? 'email' : 'phone';

      const fieldErrors = error.error?.[field];

      if (Array.isArray(fieldErrors) && fieldErrors.length) {
        this.errorText = fieldErrors[0];
        return;
      }

      const consentErrors = error.error?.consent;

      if (Array.isArray(consentErrors) && consentErrors.length) {
        this.errorText = consentErrors[0];
        return;
      }

      this.errorText = 'Проверьте введённые данные';
      return;
    }

    if (error.status === 429) {
      this.errorText =
        'Слишком много запросов. Попробуйте немного позже.';
      return;
    }

    this.errorText =
      'Не удалось отправить данные. Попробуйте ещё раз.';
  }
  onPhoneInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    
    // Оставляем только цифры и плюс в начале
    let digits = value.replace(/[^\d+]/g, '');
    
    // Если плюс не в начале — убираем все плюсы
    if (!digits.startsWith('+')) {
      digits = '+' + digits.replace(/\+/g, '');
    } else {
      digits = '+' + digits.slice(1).replace(/\+/g, '');
    }
    
    // Определяем страну по коду
    const country = this.detectCountry(digits);
    
    // Форматируем по маске
    // const formatted = this.formatByMask(digits, country.mask);
    
    this.phone.setValue(digits, { emitEvent: false });
  }
  
  private detectCountry(phone: string): Country {
    // Сортируем по длине кода (от длинного к короткому) для корректного определения
    const sortedCountries = [...countries].sort((a, b) => 
      b.code.length - a.code.length
    );
    
    for (const country of sortedCountries) {
      if (phone.startsWith(country.code)) {
        return country;
      }
    }
    
    // По умолчанию Россия
    return countries[0];
  }

  openPolicy() {
    window.open('https://careerpark.ru/policy', '_blank', 'noopener,noreferrer');
  }
  openAgreement() {
    window.open('https://careerpark.ru/terms', '_blank', 'noopener,noreferrer');
  }
}